export var popoverLocale = {
  closeLabel: 'Close'
};